import gql from 'graphql-tag';
import { client } from './client';


export const fetchImageStatus = async (key) => {
  const param = {
    'key': key,
  };
  const results = await client.query({
    query: gql`
      query ($key: String) {
        image(key: $key) {
          key
          status
        }
      }
    `,
    variables: param,
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  });
  return results.data;
};

export const fetchImage = async (key, imageB64 = false, getOriginal = false) => {
  const param = {
    'key': key,
    'imageB64': imageB64,
    'getOriginal': getOriginal,
  };

  const results = await client.query({
    query: gql`
      query ($key: String, $imageB64: Boolean, $getOriginal: Boolean) {
        image(key: $key, imageB64: $imageB64, getOriginal:$getOriginal) {
          key
          imageBytesB64
          status
        }
      }
    `,
    variables: param,
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  });
  return results.data;
};
